import Navbar from '../components/Navigation/Navbar';
import SideNav from '../components/Navigation/SideNav';
import MobileTabBar from '../components/Navigation/MobileTabBar';
import InfoCarousel from '../components/Navigation/InfoCarousel';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useTypedSelector } from '../lib/store/store';
import { selectUserState } from '../lib/features/auth/authSlice';
import { useIncompleteProfileTasksQuery } from '../lib/endpoints/profile/profile.api';

const Layout = ({ children }) => {
  const { user } = useTypedSelector(selectUserState);
  const { tasks, isLoading, error } = useIncompleteProfileTasksQuery();

  const taskMessages =
    tasks?.map((t) => (
      <span key={t.label}>
        <strong className='font-semibold text-brand-orange'>Action required:</strong>{' '}
        Please {t.label.toLowerCase()}
      </span>
    )) || [];

  const welcomeMessage = user?.firstName
    ? `Welcome back, ${user.firstName}!`
    : 'Welcome to Droomwork!';

  const infoItems = [
    ...(isLoading ? ['Syncing your profile tasks…'] : []),
    ...(error ? ['Unable to load profile tasks. Please refresh.'] : []),
    welcomeMessage,
    ...taskMessages,
    ...(taskMessages.length === 0 && !isLoading && !error
      ? ['Your profile is 100% complete!']
      : []),
    'Need help? Contact hello@droomwork.io',
  ];

  return (
    <div className='flex min-h-screen flex-col bg-surface lg:flex-row'>
      <SideNav />

      <div className='flex min-w-0 flex-1 flex-col'>
        <Navbar />
        <InfoCarousel items={infoItems} />

        <main className='min-w-0 flex-1 px-4 py-6 pb-24 lg:px-8 lg:pb-8'>
          {children}
        </main>

        <MobileTabBar />
      </div>
    </div>
  );
};

export default Layout;